import useI18n from '@/shared/hooks/usei18n'
import { RowActionsMenu } from '@/common'

export default function ImportedGoodActionsMenu({
  onView,
  onEdit,
  onDelete,
  isDisabled
}: {
  onView: () => void
  onEdit: () => void
  onDelete: () => void
  isDisabled?: boolean
}) {
  const { t } = useI18n()

  return (
    <RowActionsMenu
      onView={onView}
      onEdit={onEdit}
      onDelete={onDelete}
      isDisabled={isDisabled}
      labels={{
        view: t('common:actions.inspect'),
        edit: t('common:actions.edit'),
        delete: t('common:actions.delete')
      }}
    />
  )
}
